import React, { useState, useEffect } from 'react'
import "../styles/contact.css";
import { FaEnvelope, FaPhone} from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import Swal from 'sweetalert2';
import axios from 'axios';
import Aos from 'aos';

const Contact = () => {
useEffect(() =>{
          Aos.init({
          duration: 1000, 
          easing: 'ease-in-out', 
          once: false,  
          offset: 100, 
          });
        }, []);


  const [inputs, setInputs] = useState({
    fullname: "",
    email: "",
    message: ""
  });

 const {fullname, email, message} = inputs;

  const handleChange = (e) =>{
    const name = e.target.name;
    const value = e.target.value

    setInputs({...inputs, [name]: value});
  }

  const handleSubmit = (event) =>{
    event.preventDefault();         
    console.log(inputs);
    Swal.fire("Message sent successfully!");

    axios.post("https://jglitse.com/jglitse/contact.php", inputs) // http://localhost/jglitse/contact.php
    
    .then((response) =>{
      console.log(response.data);
    })
    setInputs({
      fullname: "", email: "", message: "" });
  }


  return (
    <div id='contact'>
       <h1 data-aos ='fade-up'>Let's Connect</h1>
       <p data-aos ='fade-up'>Let's connect and build something great together</p>
      <div className='contact'>
        <div className='contact-details' data-aos = 'fade-up'>
          <div style={{display: "flex", gap: "10px", alignItems: "center"}} >
           <FaLocationDot className='icon'/>       
           <div>
           <div className='location'>LG25, University of Ghana</div> 
           <div className='location'>Legon, Accra</div>               
            </div>  
          </div>

          <div style={{display:"flex", flexDirection: "column", gap: "15px"}}>
            <div style={{display: "flex", alignItems: "center", gap: "20px"}}>
              <FaPhone className='icon'/>
              <div className='details'>(+233) 24 742 3088</div>
              </div>

              <div style={{display: "flex", alignItems: "center", gap: "20px"}}>
              <FaEnvelope className='icon'/>
              <div className='details'>jglitse@gmail.com</div>
              </div>            
          </div>

        </div>
        <form onSubmit={(event) => handleSubmit (event)} data-aos = 'fade-up'>
          <input type='text' name='fullname' value={fullname} placeholder='Enter your full name' onChange={(e)=>handleChange(e)} required/>
          <input type='email' name='email' value={email} placeholder='Enter your email' onChange={(e)=>handleChange(e)} required/>
          <textarea type="text" name='message' value={message} placeholder='Enter your message' onChange={(e)=>handleChange(e)} required></textarea>
          <button type='submit'>Send</button>
        </form>
      </div>
    </div>
  )
}

export default Contact